import { createComponent } from "@helpers/admin";
import ComparePricingSectionComponent from "@template/blocks/ComparePricingSection/component";

export const ComparePricing = createComponent({
  label: "Compare Pricing",
  component: ComparePricingSectionComponent,
  fields: {},
});
